// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__d0xrm","choiceBoxes":"toolbarselects_choiceBoxes__2ZJ5x","simpleField":"toolbarselects_simpleField__2t1gm"};